export default __webpack_public_path__ + "static/media/certificate-one.87970f35.png";